import { Agent } from '@newrelic/browser-agent/loaders/agent';
import React, { createContext } from 'react';

import NewRelicConfig from '../newrelic/newrelicConfig';

interface NewRelicAgentContextType {
  agent: Agent;
}

const newRelicAgent: Agent = new Agent(NewRelicConfig);

export const NewRelicAgentContext = createContext<NewRelicAgentContextType>({
  agent: newRelicAgent,
});

// handle uncaught errors
window.addEventListener('error', ({ error }) => {
  newRelicAgent.noticeError(error.message);
});

export const NewRelicAgentProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => (
  <NewRelicAgentContext.Provider value={{ agent: newRelicAgent }}>
    {children}
  </NewRelicAgentContext.Provider>
);
